
export default function authContentTypeHeader () {
  return { accept: 'application/json', 'Content-Type': 'application/json' }
}
